import { createTermsTagsManager } from '../../utils/createTermsTagsManager';

export const newbuildingCompletionYearTagsManager = createTermsTagsManager({
  jsonQueryKey: 'year',
  template: 'Год сдачи %s',
  id: 'newbuildingCompletionYear',
});
